export default __webpack_public_path__ + "static/media/perro.6c2eaa1f.jpg";